export const SELECT_ALL_POSTS = 'all-posts';
